import initViewportChecker from '../vendor/viewport-checker.js';

export default function () {

	initViewportChecker();

	var offset = 0;

	if ( $(window).width() < 768 ) {
		offset = 0;
	} else {
		offset = 0;
	}

	$('.animate-block').viewportChecker({
		classToAdd: 'come-in',
		offset: offset
	});

	$('.animate-now').addClass('come-in');

	$('.products.list .products__item:nth-child(1), .products.grid .products__item:nth-child(1), .products.grid .products__item:nth-child(2), .products.grid .products__item:nth-child(3)').addClass('come-in');

}


// WEBPACK FOOTER //
// ./scripts/components/SetupAnimations.js